import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from '../../configuration/services';
import { OrdersCoServices } from '../services';
import { OrdersSelectPage } from '../orders-select/orders-select';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the TpvLoaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-positions',
  templateUrl: 'orders-positions.html',
})
export class OrdersPositionsPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public configurationServices: ConfigurationServices,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public translate:TranslateService) {

    this.ordersCoServices.getOrders(this.globals.restaurant_uid, this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);
  }


  openModSelect(i, j, element) {
    if (element.sections[i].list[j].type == 'combo' || element.sections[i].list[j].uid_element_combo != '') {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-no-puedes-cambia-posicion-combo'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    } else {
      this.ordersCoServices.i = i;
      this.ordersCoServices.j = j;
      this.ordersCoServices.element = element;
      this.ordersCoServices.update_state = true;
      this.navCtrl.push(OrdersSelectPage);
    }
  }

  async onChange(val, i, j, element) {
    //loadingPopup
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();

    //insert in new section 
    for (let _sect of element.sections) {
      if (_sect.name == val) {
        _sect.list.push(element.sections[j].list[i]);
      }
    }
    //eliminate of old sectio
    element.sections[j].list.splice(i, 1);
    //update canvis sections
    await this.ordersCoServices.afs.collection('orders').doc(element.UID).update({
      sections: element.sections,
    }).then(doc => {
      loadingPopup.dismiss();
    });
  }

  back() {
    this.navCtrl.pop();
  }

  async saveQuit() {
    var orders = await this.ordersCoServices.getOrdersF(this.globals.restaurant_uid, this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);

    for (let order of orders) {
      for (var i = 0; i < order.sections.length; i++) {
        if (Object.keys(order.sections[i].list).length == 0) {
          order.sections.splice(i, 1);
        }
      }
      await this.updateOrderSections(order)
    }
  }

  async updateOrderSections(order) {
    await this.ordersCoServices.afs.collection('orders').doc(order.UID).update({
      sections: order.sections,
    }).then(doc => {
    });
  }

  ionViewWillLeave() {
    this.saveQuit();
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-positions/orders-positions.ts